import moment from 'moment'

import $store from '@/store'
import Mustache from 'mustache'
import EventModel from './event.js'
import SettingsModel from './settings.js'

import datelib from '../lib/date.js'

export default {
	title (tag, default_text) {
		var form =  SettingsModel.get_by_id(tag.meta.type);
		if(typeof(form) == "undefined" || typeof(form.value.title_format) == "undefined") return default_text || "-";
		return Mustache.render(form.value.title_format, tag);
	},
	formatted_time (tag) {
		return datelib.format_time(tag.time);
	},
	formatted_date (tag) {
		return datelib.format_date(tag.time);
	},
	formatted_stream_time (tag, paddedHours) {
		var time = tag.stream_time;
		if(time < 0) return "-";
		time = time * 1000
  	time = parseInt(time/1000)
  	const seconds = time % 60
  	time = parseInt(time/60)
  	const minutes = time % 60
  	time = parseInt(time/60)
  	const hours = time % 24
  	const days = parseInt(time/24)
  	let out = ''
  	if (days && days > 0) {
    	out += days + ':'
    	if (hours < 1) out += '00:'
  	}
  	if (hours && hours > 0 || paddedHours) out += ('0' + hours).slice(-2) + ':'
  	out += ('0' + minutes).slice(-2) + ':'
  	out += ('0' + seconds).slice(-2)
  	return out.trim()
	},
	parsed_stream_time(time) {
		var times = time.split(":").reverse();
		var ret = 0;
		if (typeof(times[0]) != "undefined") ret = ret + (parseInt(times[0], 10)); // seconds
		if (typeof(times[1]) != "undefined") ret = ret + (parseInt(times[1], 10) * 60); // minutes
		if (typeof(times[2]) != "undefined") ret = ret + (parseInt(times[2], 10) * 60 * 60); // hours
		if (typeof(times[3]) != "undefined") ret = ret + (parseInt(times[3], 10) * 60 * 60 * 24); // days
		return ret;
	}
}